import { ParsedUrlQuery } from 'querystring';
import { PRODUCT_CATEGORIES } from 'search/enums/constants';
import { IFacetOption } from 'shared/types/ConstructorFacet';

import { getFiltersQuery } from 'search/utils/getFiltersQuery';
import { PLP_SUBCATEGORIES } from 'shared/enums/category';

interface IFiltersLinkHref {
  pathname: string;
  query: ParsedUrlQuery;
  option: IFacetOption;
  facetType: string;
}

// Util function used specifically for brand pages to create interlinks for bots to crawl
// This will enable bots to crawl more of the brands that are available on goat
export const getCrawlerFiltersLinkHref = ({
  pathname,
  query,
  option,
  facetType,
}: IFiltersLinkHref) => {
  if (facetType === 'brand') {
    const optionValue = option?.value?.replace(/\s+/g, '-');
    const category = pathname?.split?.('/')?.[1];
    let subCategory = pathname?.split?.('/')?.[2];
    const isPlpSubCategory = PLP_SUBCATEGORIES.has(subCategory) || query?.subCategory;

    if (isPlpSubCategory && !query?.pageSlug) {
      // example of dynamic paths /bags/[subCategory] or /accessories/[subCategory]
      const isDynamicPath = /\[(.*?)]/.test(subCategory);
      if (isDynamicPath) {
        subCategory = query?.subCategory as string;
      }
      //  ex. /apparel/tops links to /apparel/brand/air-jordan/tops
      return `/${category}/brand/${optionValue}/${subCategory}`;
    }

    if (Object.keys(query).length > 1) {
      // ex. /sneakers/silhouette/air-jordan-1 or sneakers/color/black
      if (query?.silhouette || query?.colorValue) {
        // links to /sneakers/brand/air-jordan
        return `/${query.pageSlug as string}/brand/${optionValue}`;
      }

      // links to /brand/air-jordan
      return `/brand/${optionValue}`;
    }

    const pathnameOrigin = pathname.split('/')[1];
    if (pathnameOrigin && PRODUCT_CATEGORIES.includes(pathnameOrigin)) {
      // links to /sneakers/brand/air-jordan
      return `/${pathnameOrigin}/brand/${optionValue}`;
    }
  }

  return {
    pathname,
    query: getFiltersQuery(query, facetType, option),
  };
};
